<template>
    <BorrarModalComponent
        :name="'borrar-sancion-' + sancion.id"
        :title="'Borrar sanción de' + deportista.nombre + ' ' + deportista.apellidos"
        borrarTitle="Datos del deportista"
        confirmButton="¿BORRAR SANCIÓN?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarDeportista()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nombre: </b> <a>{{ deportista.nombre }}</a>
            </li>
            <li class="list-group-item">
                <b>Apellidos: </b> <a>{{ deportista.apellidos }}</a>
            </li>
            <li class="list-group-item">
                <b>DNI: </b> <a>{{ deportista.dni }}</a>
            </li>
            <li class="list-group-item">
                <b>Email: </b> <a>{{ deportista.email }}</a>
            </li>
            <li class="list-group-item">
                <b>Fecha: </b>
                <a>{{ sancion.fecha }}</a>
            </li>
            <li class="list-group-item">
                <b>Sin jugar hasta: </b>
                <a>{{ sancion.sin_jugar_hasta }}</a>
            </li>
            <li class="list-group-item">
                <b>Pagado: </b>
                <a>
                    <CheckOrCross :condition="sancion.pagado.id"/>
                </a>
            </li>
            <li class="list-group-item">
                <b>Impuesta: </b>
                <a>{{ sancion.impuesta.nombre }}</a>
            </li>
            <li class="list-group-item">
                <b>Pagar: </b>
                <a>{{ sancion.pagar.nombre }}</a>
            </li>
            <li class="list-group-item">
                <b>Motivo: </b>
                <a v-html="sancion.motivo"></a>
            </li>
            <li class="list-group-item">
                <b>Sancion: </b>
                <a v-html="sancion.sancion"></a>
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>

    import CheckOrCross from "../../../../components/backend/components/CheckOrCross";
    import BorrarModalComponent from "../../../../components/backend/components/BorrarModalComponent";

    export default {
        props: ['deportista', 'sancion'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-sancion-' + this.sancion.id, borrado);
            },
            borrarDeportista() {
                console.log(this.$route.params.base_id)
                const params = {
                    filters : {},
                    lista_id: this.$route.params.lista_id,
                    base_id: this.$route.params.base_id,
                    sancion_id: this.sancion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.sanciones.borrar'), params).then(() => {
                    this.$toast.success('Sanción borrada correctamente.');
                    this.$emit('getSanciones');
                    this.close(true);
                }).catch(e => {
                    this.$toast.error(e.response?.data?.message);
                })
            }
        },
        components: {
            BorrarModalComponent,
            CheckOrCross
        }
    }
</script>
